class Header {
	stateClasses = {
		open: 'header--open',
		navOpen: 'nav--open',
		hidden: 'header--hidden',
	};

	constructor($el) {
		this.$el = $el;
		this.$body = $('body');
		this.$burger = this.$el.find('[data-burger="el"]');
		this.$parentItems = this.$el.find(
			'.navigation__top > .navigation__group > .navigation__item'
		);
		this.desktopMq = window.matchMedia('(min-width: 992px)');
		this.isTrackingDesktopHover = false;
		this.lastScrollTop = 0;
		this.hideAfter = 100;

		this.init();
	}

	init = () => {
		this.bindEvents();
		this.syncMobileState();
	};

	bindEvents = () => {
		if (this.$parentItems.length) {
			this.$parentItems.on('mouseenter', this.onParentEnter);
		}

		if (this.$burger.length) {
			this.$burger.on('click', this.onBurgerClick);
		}

		$(window).on('resize', this.onResize);
		$(window).on('scroll', this.onScroll);
		$(document).on('burger:close', this.onBurgerClose);
		$(document).on('mousemove', this.onDocumentMouseMove);
	};

	onParentEnter = () => {
		if (!this.desktopMq.matches) return;

		this.openDesktop();
	};

	onDocumentMouseMove = event => {
		if (!this.desktopMq.matches) return;
		if (!this.isTrackingDesktopHover) return;

		const el = this.$el.get(0);
		if (!el) return;

		const rect = el.getBoundingClientRect();
		const isInsideHeaderArea =
			event.clientX >= rect.left &&
			event.clientX <= rect.right &&
			event.clientY >= rect.top &&
			event.clientY <= rect.bottom;

		if (!isInsideHeaderArea) {
			this.closeDesktop();
		}
	};

	onScroll = () => {
		const currentScrollTop = $(window).scrollTop();

		if (currentScrollTop < this.hideAfter) {
			this.$el.removeClass(this.stateClasses.hidden);
		} else if (!this.$el.hasClass(this.stateClasses.open)) {
			if (currentScrollTop > this.lastScrollTop) {
				this.$el.addClass(this.stateClasses.hidden);
			} else {
				this.$el.removeClass(this.stateClasses.hidden);
			}
		}

		this.lastScrollTop = currentScrollTop;
	};

	openDesktop = () => {
		this.$el.removeClass(this.stateClasses.hidden);
		this.$el.addClass(this.stateClasses.open);
		this.isTrackingDesktopHover = true;
	};

	closeDesktop = () => {
		this.$el.removeClass(this.stateClasses.open);
		this.isTrackingDesktopHover = false;
	};

	onBurgerClick = () => {
		if (this.desktopMq.matches) return;

		window.setTimeout(() => {
			this.syncMobileState();
		}, 0);
	};

	onBurgerClose = () => {
		if (this.desktopMq.matches) return;
		this.$el.removeClass(this.stateClasses.open);
	};

	onResize = () => {
		if (this.desktopMq.matches) {
			this.closeDesktop();
		} else {
			this.syncMobileState();
		}
	};

	syncMobileState = () => {
		if (this.desktopMq.matches) return;

		this.$el.toggleClass(
			this.stateClasses.open,
			this.$body.hasClass(this.stateClasses.navOpen)
		);
	};
}

export default Header;
